import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useDynamicLink } from '../DynamicUse';
import { dynamicUrl } from '../Function';
import { Container, Row, Col, Image, Card, Carousel, Placeholder } from 'react-bootstrap';
const HpAboutSection = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const dynamicLinkData = useDynamicLink(10);
    const [isLoading, setLoading] = useState(true);
    const [hpSlider, setSlider] = useState([]);
    useEffect(() => {

        const getSlider = async () => {
            try {
                const response = await fetch(global.config.API_URL + "slider/byType/36");
                const result = await response.json();
                if (result.length > 0) {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {
                        allResponse.forEach((el, i) => {
                            result[i].slideImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].slideImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setSlider(result);
                    }).catch(error => {
                        console.error('Slider File:', error);
                    });
                }
                if (global.config.IsPrint === true) { console.info('Slider : Result', result); }
            } catch (error) {
                console.error('Slider : Error', error.message);
            } finally {
                setLoading(false);
            }
        };
        getSlider();
    }, []);
    return (
        <section className="hp-about text-start py-md-5 py-3">
            <Container className="py-3">
                <Row className="g-4">
                    <Col lg={6} data-aos="fade-right" data-aos-duration="1500">
                        <h2>{appLanguage === 'hi' ? 'विश्वविद्यालय के बारे में' : 'About the University'}</h2>
                        <span className="mb-4 sub-heading"></span>
                        <p className="text-justify mb-4">
                            {appLanguage === 'hi' ? 'इंदिरा गांधी दिल्ली महिला तकनीकी विश्वविद्यालय (आईजीडीटीयूडब्लू) की स्थापना दिल्ली सरकार द्वारा मई, 2013 में दिल्ली अधिनियम 09/2012 के तहत एक गैर-संबद्ध विश्वविद्यालय के रूप में की गई थी, जिसका उद्देश्य महिलाओं के बीच व्यावसायिक शिक्षा के उभरते क्षेत्रों में अध्ययन, अनुसंधान, प्रौद्योगिकी, नवाचार, ऊष्मायन और विस्तार कार्य को सुविधाजनक बनाना और बढ़ावा देना है, जिसका उद्देश्य इंजीनियरिंग, प्रौद्योगिकी, अनुप्रयुक्त विज्ञान, वास्तुकला और इसके संबद्ध क्षेत्रों पर ध्यान केंद्रित करना है, जिसका उद्देश्य इन और संबंधित क्षेत्रों में उत्कृष्टता प्राप्त करना है।' : 'Indira Gandhi Delhi Technical University for Women (IGDTUW) was established by the Govt. NCT of Delhi in May, 2013 vide Delhi Act 09 of 2012, as a non affiliating University to facilitate and promote studies, research, technology, innovation, incubation and extension work in emerging areas of professional education among women, with focus on engineering, technology, applied sciences, architecture and its allied areas with the objective to achieve excellence in these and related fields.'}
                        </p>
                        <p className="text-justify mb-4">
                            {appLanguage === 'hi' ? 'इंदिरा गांधी प्रौद्योगिकी संस्थान (आईजीआईटी) की स्थापना 1998 में प्रशिक्षण एवं तकनीकी शिक्षा निदेशालय, दिल्ली सरकार द्वारा केवल महिलाओं के लिए पहला इंजीनियरिंग कॉलेज के रूप में की गई थी। 2002 में, यह कॉलेज गुरु गोविंद सिंह इंद्रप्रस्थ विश्वविद्यालय का पहला घटक कॉलेज बन गया।' : 'Erstwhile Indira Gandhi Institute of Technology (IGIT) was established in 1998 by Directorate of Training and Technical Education, Govt. of NCT of Delhi as the first engineering college for women only. In 2002, the college became the first constituent college of Guru Gobind Singh Indraprastha University.'}
                        </p>
                        {dynamicLinkData && dynamicLinkData.map((sp,index)=>(
                            <NavLink to={dynamicUrl(sp)} className="btn btn-lg btn-info rounded-0" key={index}>
                                {t('ReadMore')} <i className="bi bi-arrow-right-short"></i>
                            </NavLink>
                        ))}                        
                    </Col>
                    <Col lg={6}>
                        <Card data-aos="fade-left" data-aos-duration="1500">
                            {/* 11343,10905,10906,11344 */}
                            {isLoading ? (
                                <Carousel id='bs-slider'>
                                    {[...Array(5)].map((_, index) => (
                                        <Carousel.Item key={index}>
                                            <Placeholder xs={12} className="d-block w-100" bg="light" style={{ height: "400px" }} />
                                        </Carousel.Item>
                                    ))}
                                </Carousel>
                            ) : (                            
                                <Carousel id='bs-slider'>
                                    {hpSlider.slice(0, 7).map((hs, index) => (
                                        <Carousel.Item key={index}>
                                            {appLanguage === 'hi' ? (
                                                hs.ss_display_en === "1" && hs.slideImageHi ? (
                                                    <Image
                                                        src={hs.slideImageHi}
                                                        fluid
                                                        width={732}
                                                        height={488}
                                                        alt={hs.ss_name_hi || hs.ss_name}
                                                        loading="lazy"
                                                    />
                                                ) : hs.slideImageHi ? (
                                                    <Image
                                                        src={hs.slideImageHi}
                                                        fluid
                                                        width={732}
                                                        height={488}
                                                        alt={hs.ss_name_hi || hs.ss_name}
                                                        loading="lazy"
                                                    />
                                                ) : hs.slideImage ? (
                                                    <Image
                                                        src={hs.slideImage}
                                                        fluid
                                                        width={732}
                                                        height={488}
                                                        alt={hs.ss_name_hi || hs.ss_name}
                                                        loading="lazy"
                                                    />
                                                ) : null
                                            ) : (
                                                hs.slideImage ? (
                                                    <Image
                                                        src={hs.slideImage}
                                                        fluid
                                                        width={732}
                                                        height={488}
                                                        alt={hs.ss_name}
                                                        loading="lazy"
                                                    />
                                                ) : null
                                            )}
                                        </Carousel.Item>
                                    ))}
                                    <Carousel.Item>
                                        <Image src={global.config.uploadPath+'600705579.jpg'} fluid width={732} height={488} alt={appLanguage === 'hi' ? 'आईजीडीटीयूडब्लू प्रवेश द्वार धारक के रूप में' : 'IGDTUW Entry Gate as holder'} />
                                        <div className="carousel-caption d-block d-print-none">
                                            <div className="ratio ratio-4x3">
                                                <iframe title={appLanguage === 'hi' ? 'आईजीडीटीयूडब्लू लाइफ यूट्यूब वीडियो' : 'IGDTUW Life Youtube Video'} src="https://www.youtube.com/embed/alyJeRLX7Pg?rel=0&cc_load_policy=1" allowFullScreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </Carousel.Item>   
                                </Carousel>
                            )}                     
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>        
    );
    
}
export default HpAboutSection;